import { ensureFreshAccessToken } from '../api/client';

// Возвращает актуальный access-token. Если в памяти нет — форсирует refresh
// через httpOnly-cookie (см. ensureFreshAccessToken в api/client). Нужен для
// мест, где Bearer должен быть в момент первого запроса — например, в URL
// веб-сокета, который мы открываем до/параллельно автологину.
export async function getFreshAccessToken(): Promise<string> {
  return ensureFreshAccessToken();
}
